<template>
  <div
    id="login-container"
    class="red"
  >
    <license-first-login-form-windows
      v-if="platformAuthentication?.osType.value === OsType.Windows"
      @loading="val => $emit('loading', val)"
    />
    <license-first-login-form-linux
      v-else
      @loading="val => $emit('loading', val)"
    />
  </div>
</template>

<script>
import LicenseFirstLoginFormWindows from '@/views/login/loginComponents/OS/licenseFirstLoginForm.windows.vue';
import LicenseFirstLoginFormLinux from '@/views/login/loginComponents/OS/licenseFirstLoginForm.linux.vue';
import router from '@/router';
import { defineComponent, inject } from 'vue';
import { useCommonDataQuery } from '@/graphql/codegen/generated/graphql';
import { IKCoordinatorsService } from '@/modules/CoordinatorsService/CoordinatorService.InjectionKeys';
import { IKPlatformAuthentication } from '@/modules/platformAuthentication/platformAuthentication.injectionKeys';
import { OsType } from '@/modules/platformAuthentication/platformAuthentication.const';
import LicenseScript from '../../login/loginComponents/licenseFormMixins.vue';

export default defineComponent({
  name: 'LicenseFirstLogin',
  components: {
    LicenseFirstLoginFormWindows,
    LicenseFirstLoginFormLinux,
  },
  mixins: [LicenseScript],
  setup() {
    const coordinatorsService = inject(IKCoordinatorsService);
    const platformAuthentication = inject(IKPlatformAuthentication);

    const GQL_useLicenseInfoQuery = useCommonDataQuery(() => ({
      coordinatorId: coordinatorsService?.selectedCoordinator.value || '',
    }));
    return { GQL_useLicenseInfoQuery, platformAuthentication, OsType };
  },
  computed: {
    license() {
      return this.GQL_useLicenseInfoQuery?.result?.value?.ibManagerEntities?.license;
    },
  },
  watch: {
    license() {
      this.$emit('loading', false);
      const { name: routerName = '' } = router.currentRoute.value;
      if (!['login', 'enterLicense'].includes(routerName)) {
        this.$store.commit('main/dialogState', false);
        this.dialogPresets.handleLicenseStateInfo(this.openDialog, { state: this.license?.state }, this.license?.key);
      }
    },
  },
  mounted() {
    this.$emit('loading', false);
  },
});
</script>
